import * as React from 'react';
import { translate } from 'react-i18next';
import Loadable from 'react-loadable';
import '../../assets/css/wait-spinner-card.css';
import { default as i18n } from '../../locales';
import WaitSpinnerCard from '../wait-spinner-card';

const DELAY = 300; // 0.3 seconds
const WAIT_MESSAGE: string = i18n.t('global:pleaseWaitText');
const LoadingComponent = () => (
  // ASSUMPTION: parent element's position is relative
  <div style={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0 }}>
    <WaitSpinnerCard>{WAIT_MESSAGE}</WaitSpinnerCard>
  </div>
);

// export const AsyncHomePage = Loadable({
//   delay: DELAY,
//   loading: LoadingComponent,
//   loader: () => import('../../HomePage')
// });

// export const AsyncHomePageV2 = Loadable({
//   delay: DELAY,
//   loading: LoadingComponent,
//   loader: () => import('../../HomePageV2')
// });

export const AsyncHomePageV3 = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../../HomePageV3')
});

export const AsyncAlertsPage = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../../AlertsPage')
});

export const AsyncIdentityPage = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../../IdentityPage')
});

export const AsyncProtectionPage = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../../ProtectionPage')
});
export const AsyncScamDetectionPage = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../../ScamDetectionPage')
});
export const AsyncResourceCentrePage = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../../ResourceCentrePage')
});

export const AsyncActivatePage = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../../ActivatePage')
});

export const AsyncPersonalInfoForm = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../personal-info-form')
});

export const AsyncContactInfoForm = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../contact-info-form')
});

export const AsyncContactUsPage = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../../ContactUsPage')
});

export const AsyncStaticContentPage = Loadable({
  delay: DELAY,
  loading: LoadingComponent,
  loader: () => import('../../StaticContentPage'),

  //  tslint:disable-next-line:typedef
  render(loaded, props) {
    const StaticContentPageComponent = loaded.default;
    return <StaticContentPageComponent {...props} />;
  }
});

export const AsyncTermsOfUsePage = translate('termsOfUsePage', { i18n })(AsyncStaticContentPage);
export const AsyncTermsConditionsPage = translate('termsAndConditionsPage', { i18n })(AsyncStaticContentPage);
export const AsyncPrivacyPolicyPage = translate('privacyPolicyPage', { i18n })(AsyncStaticContentPage);
export const AsyncFaqPage = translate('faqPage', { i18n })(AsyncStaticContentPage);
